<p-table
  [value]="shoppingCart.cartItems | dup"
  [rows]="25"
  [autoLayout]="true"
  [responsive]="true"
  [scrollable]="false"
>
  <ng-template pTemplate="header">
    <tr>
      <th translate>cart-item.product-name</th>
      <th translate>cart-item.product-price</th>
      <th translate>cart-item.quantity</th>
      <th translate>cart-item.total</th>
      <th translate>app.actions</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-cartItem>
    <vnm-cart-item [cartItem]="cartItem"></vnm-cart-item>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <vnm-table-empty-message icon="shopping-cart" message="shopping-cart.no-items">
      <button
        type="button"
        pButton
        [label]="'shopping-cart.browse-catalog' | translate"
        icon="fa fa-fw fa-search"
        class="mt-3"
        (click)="onBrowseCatalog()"
      ></button>
    </vnm-table-empty-message>
  </ng-template>

  <ng-template pTemplate="footer">
    <tr @fade>
      <td colspan="5"><vnm-claim-promo-code></vnm-claim-promo-code></td>
    </tr>
  </ng-template>
</p-table>
